import BaseService from './BaseService'

class GroupService extends BaseService {
  constructor() {
    super('/groups')
  }

  getMembers(groupId) {
    return this.customRequest('get', `/${groupId}/members`)
  }

  addMember(groupId, payload) {
    return this.customRequest('post', `/${groupId}/members`, payload)
  }

  removeMember(groupId, customerId) {
    return this.customRequest('delete', `/${groupId}/members/${customerId}`)
  }

  getMemberTotals(groupId) {
    return this.customRequest('get', `/${groupId}/member-totals`)
  }

  sendBillingPortalSignInLink(groupId, { confirmFirstInvite = false } = {}) {
    return this.customRequest('post', `/${groupId}/portal/sign-in-link`, {
      confirm_first_invite: confirmFirstInvite
    })
  }
}

export default new GroupService()



